import { SET_USER_BUS } from "../actions/user"

export default function user(state = [], action = {}) {
    switch (action.type) {
        case SET_USER_BUS:
            const { user, passenger, seats } = action;
            return {
                ...state,
                BusPassenger: {
                    user, passenger, seats
                }

            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/BusUserRedeucer.jsx